export default "__VITE_ASSET__KXaRpV0h__"